module.exports = __webpack_public_path__ + "static/media/logo-navbar.86034858.svg";